import React, { useState, useEffect, useCallback } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import Table from "../../Shared/Table";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import Chip from "../../Shared/StatusChip";
import { PrimaryButton } from "../../Shared/Buttons";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import ModalComp from "../../Shared/ModalComp";
import AddRestaurant from "../AddRestaurant/AddRestaurant";
import { Typography } from "@material-ui/core";
import ConfirmationModal from "../../Shared/ConfimationModal";
import RestDataAction from "../../Store/Actions/GetRestaurant-Action";
import { RestaurantAction } from "../../Store/Reducers/Restaurant-reducer";
import { useSelector, useDispatch } from "react-redux";
import { BtnStyle } from "../../Util/CSS/BtnStyle";
import LoadMoreItems from "../../Shared/LoadMoreItemsScreen";
import { useErrorHandler } from "react-error-boundary";
import SearchComp from "../../Shared/GlobalSearch";

const useStyles = makeStyles((theme) => ({
  newRestDiv: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    width: "100%",
  },
}));

const Restaurants = () => {
  const {
    restaurantData,
    searchRestaurant,
    showSearch,
    loading,
    status,
    isLoaded,
    lastEvaluatedkey,
    loadMore,
  } = useSelector((state) => state.Restaurant);
  const dispatch = useDispatch();
  let classes = useStyles();
  const history = useHistory();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });
  const ErrorHandler = useErrorHandler();
  const styles = BtnStyle();
  const [openModal, setopenModal] = useState(false);
  const [isOpen, setisOpen] = useState({
    open: false,
    content: "",
    deleteHandler: "",
    item: "",
  });

  useEffect(() => {
    dispatch(RestaurantAction.setShowSearch(false));
    if (!isLoaded) {
      dispatch(RestDataAction(lastEvaluatedkey));
      dispatch(RestaurantAction.setIsLoaded(true));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (status !== "") {
      ErrorHandler(() => {
        throw new Error(status);
      });
      handleSnackbarOpen(status, "errorDark");
    }
    return () => {
      setSnackbarOpen(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, [status]);
  const getTime = (time) => {
    let key = parseInt(time);
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };
  const TableData = (data) => {
    let tableValues = data.map((item, index) => ({
      restaurant_id: item.readableId ? item.readableId : "—",
      total_orders: item?.totalOrders ? item.totalOrders : "0",
      number: item.contactNumber ? item.contactNumber : "—",
      name: item.restaurantName ? item.restaurantName : "—",
      createdAt: item.createdAt ? getTime(item.createdAt) : "—",
      slug: item.slug ? item.slug : "—",
      status: (
        <Chip
          index={index}
          setLoading={() => {}}
          handleSnackbarOpen={handleSnackbarOpen}
          isLoading={isLoaded}
          data={data}
          comp="restaurants"
          statusKey="status"
          itemId={item.readableId}
          apiUrl={`${process.env.REACT_APP_API_URL}restaurant/${item.id}/`}
        />
      ),

      details: (
        <PrimaryButton
          size="small"
          style={{ width: "100px" }}
          handleClick={() => history.push(`/restaurants/${item.id}`)}
        >
          DETAILS
        </PrimaryButton>
      ),
    }));
    return tableValues;
  };
  
  const columns = [
    {
      name: "restaurant_id",
      label: "Restaurant Id",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "total_orders",
      label: "Total Orders",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Restaurant Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "slug",
      label: "Slug",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "number",
      label: "Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "createdAt",
      label: "Created Date",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        searchable: false,
      },
    },
    {
      name: "details",
      label: "Details",
      options: {
        filter: false,
        sort: false,
        searchable: false,
      },
    },
  ];
  const handleClose = () => {
    setopenModal(false);
  };

  const onTableChangeHandler = (action, tableState) => {
    const { page, rowsPerPage, data } = tableState;
    let diff = Math.abs(page * rowsPerPage - data.length);
    if (
      diff <= rowsPerPage &&
      lastEvaluatedkey?.id?.length > 0 &&
      (action === "changePage" || action === "changeRowsPerPage")
    ) {
      dispatch(RestDataAction(lastEvaluatedkey));
      return;
    }
  };
  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          {isOpen.open && (
            <ConfirmationModal
              open={isOpen.open}
              content={isOpen.content}
              item={isOpen.item}
              deleteHandler={isOpen.deleteHandler}
              setIsopen={setisOpen}
            />
          )}
          <div className={classes.newRestDiv}>
            <PrimaryButton handleClick={() => setopenModal(true)}>
              <Typography>Add New Restaurant</Typography>
            </PrimaryButton>
            <SearchComp
              endpoint={"restaurant/query"}
              caller={"customer"}
              options={true}
            />
          </div>
          <Table
            data={
              showSearch
                ? TableData(searchRestaurant)
                : TableData(restaurantData)
            }
            columns={columns}
            title="Restaurants"
            onTableChange={onTableChangeHandler}
          />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="center"
            />
          )}
          {openModal && (
            <ModalComp
              open={openModal}
              handleClose={handleClose}
              top={100}
              topMobile={100}
              width={700}
              minHeight={400}
            >
              <AddRestaurant
                modalClose={handleClose}
                restData={restaurantData}
              />
            </ModalComp>
          )}
        </>
      )}
    </>
  );
};

export default Restaurants;